var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConnection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "110px",
    height: "118px",
    viewBox: "0 0 110 118",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Connection") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Error-and-Alert-Messages",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Error-Handling---404/Timeout",
    transform: "translate(-246.000000, -409.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Connection",
    transform: "translate(246.000000, 409.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.245878,14.4286704 C85.6727431,20.1652888 89.8787693,28.1693115 96.6312622,39.6737639 C103.415175,51.1782164 112.769835,66.1816797 109.222205,75.1264341 C105.674576,84.0711884 89.1618168,86.954396 73.570242,92.8201344 C57.9786672,98.6858727 43.2997073,107.500088 29.7961496,105.781799 C16.2925919,104.063509 3.96443639,91.8155522 0.86383102,78.2693006 C-2.26819458,64.6904143 3.79876609,49.8160711 8.16903437,36.2698195 C12.5078824,22.7249869 15.1500381,10.5025703 22.749449,4.96885487 C30.34886,-0.564860543 42.9083826,0.624178821 53.5427021,2.92421797 C64.1755934,5.25263515 72.8190129,8.69347102 79.245878,14.4286704 Z",
    id: "Path",
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.6884197,47.2884181 C59.7765822,48.9946969 59.5438596,113.769231 59.5438596,113.769231 L63.7084352,113.769231 L71.4059126,71.1790871 C71.4967877,69.8020902 72.8070175,54.5783348 72.8070175,54.5783348 L64.5333097,46.4230769 L59.6884197,47.2884181 Z",
    id: "Path",
    fill: "#1E428A",
    transform: "translate(66.175439, 80.096154) scale(-1, 1) translate(-66.175439, -80.096154) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.5317284,46.4230769 C65.5317284,46.4230769 70.5789474,79.5309808 70.5789474,80.8787593 C70.5789474,82.2265377 62.7454588,113.769231 62.7454588,113.769231 L58.2192982,113.769231 L61.6821116,77.5549343 L49.3157895,47.7656415",
    id: "Path",
    fill: "#1E428A",
    transform: "translate(59.947368, 80.096154) scale(-1, 1) translate(-59.947368, -80.096154) "
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    fill: "#000000",
    transform: "translate(56.359649, 115.538462) scale(-1, 1) translate(-56.359649, -115.538462) ",
    points: "51.0438596 113.769231 51.0438596 117.307692 61.6754386 117.307692 61.6754386 115.309048 55.5700202 113.769231"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    fill: "#000000",
    transform: "translate(67.491228, 115.538462) scale(-1, 1) translate(-67.491228, -115.538462) ",
    points: "62.1754386 113.769231 62.1754386 117.307692 72.8070175 117.307692 72.8070175 115.931624 66.3400142 113.769231"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0203861,7.69185998 C53.1090064,7.26300329 53.5149664,6.96673088 53.9642793,7.00300007 C54.5170485,7.04080336 55.4205304,8.45772658 55.4205304,9.6044263 C55.4205304,10.751126 55.0871369,11.1823635 55.1881653,12.015436 C55.2891936,12.8485084 57.4757352,24.1446908 57.4757352,24.8335507 C58.0270612,24.871354 60,24.6039307 60,24.6039307 L58.6187985,30 L54.5978712,30 L52,8.2659099 L53.0203861,7.69185998 Z",
    id: "Path-Copy",
    fill: "#D37C59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57,9.004902 L56.1867176,12 C56.1867176,12 48.1633471,11.1502104 47.2877176,10.9532309 C46.4120882,10.7562515 47.7310743,5.80398572 48.6302571,6.00601594 C49.5294399,6.20804616 57,9.004902 57,9.004902 Z",
    id: "Path-Copy-2",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.5797783,19.5 C70.9109837,19.5 73.9060256,45.5713648 72.7030562,47.1612398 C71.0621695,49.3301912 59.3218141,51.0764685 54.4565003,47.6188135 C53.9332169,44.824715 52.889873,21.7157398 63.5797783,19.5 Z",
    id: "Path",
    fill: "#007CBA",
    transform: "translate(63.559543, 34.538462) scale(-1, 1) translate(-63.559543, -34.538462) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.594743,26.7560016 C61.002482,26.953189 57.5289512,28.2834893 57.5289512,28.2834893 C57.4707438,27.5976202 54.8004761,13.9945491 54.63604,13.1615039 C54.9730321,12.3300248 55.139679,11.4414382 55.1264379,10.5466279 C55.1264379,8.31326651 54.2023944,6.5 53.0629831,6.5 C51.9235719,6.5 51.0009835,8.31326651 51.0009835,10.5466279 C50.9848119,11.4814098 51.168223,12.4091534 51.5394026,13.2700999 C51.4113462,14.9704837 50.2617487,31.1155573 52.6075097,33.4175055 C55.0813272,35.8466254 61.0956139,33.6561308 64.751043,32.0243339 C65.5339335,31.7585596 64.4672816,25.9929722 61.594743,26.7560016 Z",
    id: "Path-Copy-3",
    fill: "#DE8E68"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy",
    fill: "#000000",
    transform: "translate(56.742060, 11.089577) rotate(14.870000) translate(-56.742060, -11.089577) ",
    points: "55.6358914 10.3196765 57.8496404 10.3176549 57.8482278 11.8594778 55.6344789 11.8614994"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.7401678,25.504388 C72.3604369,28.6808932 65.9439417,34.4035296 64.1686778,33.9774837 C62.393414,33.5514379 59.5303167,27.1549534 60.0656226,26.0072381 C60.6009285,24.8595227 69.1643879,22.4133818 70.7401678,25.504388 Z",
    id: "Path-Copy-4",
    fill: "#007CBA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65,21.5885938 C65,22.0739328 62,22.1969028 62,21.5885938 L62,16 L65,16 L65,21.5885938 Z",
    id: "Path-Copy-5",
    fill: "#D37C59"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-Copy",
    fill: "#DC8E6C",
    cx: 62,
    cy: 12.5,
    rx: 4,
    ry: 6.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.3581682,8.02356446 C59.2929459,9.0642063 59.769133,10.0607661 60.6038676,10.6305525 C61.8581089,11.524377 62.7521651,11.1296046 63.6718472,11.9712893 C64.157314,12.4792795 65.3460671,13.4609967 65.3574564,14.977519 C65.3574564,16.0992687 64.8484516,16.5902902 65.1573851,16.5902902 C65.4663185,16.5902902 67.1412979,16.4419014 67.6652035,16.4419014 C72.8102978,16.4419014 78.8522956,22 90.4437063,22 C96.498517,22 106,20.4015439 106,11.096831 C106,6.07204767 104.271681,0 95.1360778,0 C89.3346779,0 85.2701388,2.97941495 80.5037371,2.97941495 C74.3820145,2.97941495 72.0215921,0.659940412 67.7919089,0.659940412 C64.7794519,0.659940412 58,2.48632178 58,7.27126219 C58,9.08870531 58.265478,9.50271546 58.4334695,9.59656703 C58.4875684,9.39694623 59.0976391,8.47941495 59.3581682,8.02356446 Z",
    id: "Path-Copy-6",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-2",
    fill: "#DC8E6C",
    cx: 64.5,
    cy: 13,
    r: 1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnection);
export default __webpack_public_path__ + "static/media/Connection.c5eed924d2e859430fb4dbc79d53ade2.svg";
export { ForwardRef as ReactComponent };